
import * as React from 'react';
import {
    Box,
    Stack,
    Skeleton,
    Button,
    ModalOverlay,
    ModalContent,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    Modal,
    ModalHeader,
    useDisclosure,
    FormControl,
    FormLabel,
    Input,
    Heading,
    useToast,
    Flex,
} from "@chakra-ui/react";

import EventHeader from "./detailSegments/header";
import EventTimeline from "./detailSegments/timeline";
import EventGifts from "./detailSegments/gifts";
import EventDresscode from "./detailSegments/dresscode";
import EventQuestions from "./detailSegments/questions";
import EventIntro from "./detailSegments/intro";
import InviteGallery from "./inviteGallery";
import ResponseBpController from "../response/breakpointController";
// import '../../styles/customSrollbar.css'

import { getGuestByInviteCode, getGuestAllocatedAddtlGuest } from "../../service/api/event";

// import inviteImg from '../../assets/images/svg/3.png'

// import { getGuestByInviteCode } from '../service/api/event'
// import getGuestByInviteCode from '../../service/api/event'

import { useLocation, useNavigate } from 'react-router-dom';

function useQuery() {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
}


function MainDetails() {
    const { isOpen, onOpen, onClose } = useDisclosure({ defaultIsOpen: false })
    const [pageLoad, setPageLoad] = React.useState(true);
    const [pageEmpty, setPageEmpty] = React.useState(true);
    const [pageError, setPageError] = React.useState(false);
    const [inviteCode, setInviteCode] = React.useState('');
    const [tmpInviteCode, setTmpInviteCode] = React.useState('');
    const [inviteId, setInviteId] = React.useState(null);

    // guest details
    const [guestFirstName, setGuestFirstName] = React.useState('');
    const [guestLastName, setGuestLastName] = React.useState('');
    const [allocatedAddtlGuest, setAllocatedAddtlGuest] = React.useState([]);
    const [apiAddtlGuest, setApiAddtlGuest] = React.useState(null);

    // API calls
    const [guestDetails, setGuestDetails] = React.useState(null);

    const toast = useToast();
    const navigate = useNavigate();
    let query = useQuery();

    const handleInviteCodeTry = () => {
        navigate('/guest/respond/')
        setPageLoad(true);
        setTmpInviteCode('');
        setInviteCode('')
    }

    const handleSubmit = (event) => {
        event.preventDefault();

        // Validate inputs
        if (!tmpInviteCode) {
            toast({
                title: "Missing invite code.",
                description: "Please fill in invite code field.",
                status: "warning",
                duration: 3000,
                isClosable: true,
            });
            return;
        }
        (async () => {
            setGuestDetails((await getGuestByInviteCode(tmpInviteCode)))
        })();
        // Redirect to a URL with form data
        // history.push(`/redirect-url?name=${encodeURIComponent(name)}&email=${encodeURIComponent(email)}`);
        navigate(`/guest/respond/?invitecode=${encodeURIComponent(tmpInviteCode)}`);
    };

    React.useEffect(() => {
        setInviteCode(query.get("invitecode"));

        if (inviteCode) {
            onClose();

            if (guestDetails === null) {
                (async () => {
                    setGuestDetails((await getGuestByInviteCode(inviteCode)))

                })();
            }
            if (guestDetails != null) {
                onClose();

                if (guestDetails.status === 200) {
                    setPageLoad(false);
                    setPageEmpty(false);

                    setGuestFirstName(guestDetails.data.first_name)
                    setGuestLastName(guestDetails.data.last_name)
                    setInviteId(guestDetails.data.id)
                    // if (guestDetails.data.allocated_addtl_guests) {
                    setAllocatedAddtlGuest(guestDetails.data.allocated_guests)
                    // }

                } else if (guestDetails.status === 204) {
                    setPageLoad(false);
                    setPageEmpty(true);
                } else {
                    setPageLoad(false);
                    setPageError(true);
                }
            }
        } else {
            onOpen();
        }
    });

    if (pageLoad) {
        return (
            <Box padding={10}>
                <Stack>
                    <Skeleton height='20px' />
                    <Skeleton height='20px' />
                    <Skeleton height='20px' />
                </Stack>
                <Modal padding={4} blockScrollOnMount={true} isOpen={isOpen} onClose={onClose}>
                    <ModalOverlay />
                    <ModalContent maxW='45vh'>
                        <ModalHeader>
                            We will check your invitation code
                        </ModalHeader>
                        <ModalCloseButton />
                        <form onSubmit={handleSubmit}>
                            <ModalBody>
                                <FormControl>
                                    <FormLabel>Invite Code</FormLabel>
                                    <Input
                                        onChange={
                                            (e) => setTmpInviteCode(e.target.value)}
                                        value={tmpInviteCode}
                                        type="text"
                                        textTransform="lowercase"
                                        _placeholder={{
                                            textTransform: 'none'
                                        }}
                                        placeholder='Enter your invite code.' />
                                </FormControl>
                            </ModalBody>
                            <ModalFooter>
                                <Button type="submit" colorScheme="teal" margin={3}>Find my invitation</Button>
                            </ModalFooter>
                        </form>

                    </ModalContent>
                </Modal>
            </Box>


        )
    } else if (pageEmpty) {
        return (
            <div>
                <Flex height="100vh"
                    justifyContent="center"
                    alignItems='center'
                >
                    <Stack direction='column'>
                        <Box>
                            <Heading>
                                Invite code does not exist
                            </Heading>
                        </Box>
                        <Button colorScheme="teal" onClick={handleInviteCodeTry}>
                            Try again
                        </Button>
                    </Stack>

                </Flex>

            </div>
        )

    } else if (pageError) {
        return (
            <div>
                <Box overflowY="auto"
                    height="100%"
                    border="1px"
                    margin={30}
                    borderColor="gray.200">
                    <Heading>
                        We're having some diffculties please check again later.
                    </Heading>
                </Box>
            </div>
        )

    }
    else if (guestDetails) {
        return (
            <Box>
                <InviteGallery />
                <Box overflowY="auto" padding={0}>
                    <ResponseBpController
                        firstName={guestFirstName}
                        lastName={guestLastName}
                        allowedAddtlGuest={allocatedAddtlGuest}
                        inviteCode={inviteCode}
                        inviteId={inviteId}
                    />
                </Box>
                
            </Box>
        )
    }



}

export default MainDetails;